import clsx from "clsx";
import { useEVMContext } from "../context/EVMContext";

const ConnectWalletBtn = ({
    className
}: {
    className?: string
}) => {
    const { isWalletLoading, connectEVMWallet } = useEVMContext();

    return <button
        onClick={connectEVMWallet}
        disabled={isWalletLoading}
        className={clsx(
            "bg-black dark:bg-white hover:opacity-80 transition-all duration-300 font-normal py-2 px-4 md:px-6 rounded-[100px] h-[40px] md:h-[46px] text-sm md:text-base",
            isWalletLoading ? 'opacity-50 cursor-not-allowed' : '',
            "text-white dark:text-black",
            className
        )}
    >
        {isWalletLoading ? 'Connecting...' : 'Connect Wallet'}
    </button>
};

export default ConnectWalletBtn;
